export default "__VITE_ASSET__GZs9xyaa__"